import { IEMModelDetail } from './model_section/IEMModelDetail.tsx';
import { ShellsList } from './shell_section/ShellsList';
import { FaceplatesMaterialList } from './faceplate_section/FaceplatesMaterialList';
import { CableSection } from './cable_section/CablePicker';
import FinalizeSection from './finalize_section/FinalizeSection';
import { CarePlan } from './care_plan/CarePlan';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { ArtworkController } from './artwork_section/ArtworkController';
import layout from '../styles/layout.module.css';
const ChoiceList = ({ width, onFlip, onMirror, onReset, onCenter }) => {
    const currentCategory = useSelector(
        (state) => state.rootReducer.currentCategory.activeCategory
    );

    const currentlyDisplayed = () => {
        switch (currentCategory) {
            case 'Model':
                return <IEMModelDetail width={width} />;
            case 'Care_plan':
                return <CarePlan />;
            case 'Shell':
                return <ShellsList />;
            case 'Faceplate':
                return <FaceplatesMaterialList width={width} />;
            case 'Artwork':
                return (
                    <ArtworkController
                        width={width}
                        onFlip={onFlip}
                        onMirror={onMirror}
                        onReset={onReset}
                        onCenter={onCenter}
                    />
                );
            case 'Cable':
                return <CableSection style={{ marginTop: '10%' }} />;
            case 'Finalize':
                return <FinalizeSection />;
        }
    };

    return (
        <Box
            className={
                currentCategory === 'Model' ||
                currentCategory === 'Finalize' ||
                currentCategory === 'Care_plan'
                    ? layout.modelContainer
                    : layout.optionContainer
            }>
            {currentlyDisplayed()}
        </Box>
    );
};

export default ChoiceList;
